import * as Sentry from '@sentry/react';
export const reportUnusableIntercomJwt = (param)=>{
    let { refreshResult, secondsUntilExpiry, identity } = param;
    var _refreshResult_httpStatus;
    if (refreshResult.receivedUserInfo) {
        Sentry.captureMessage('Intercom JWT near or past expiry at boot', {
            level: 'warning',
            tags: {
                context: 'intercom_jwt_stale'
            },
            extra: {
                userId: identity.userId,
                userEmail: identity.email,
                secondsUntilExpiry,
                jwtPresentInResponse: refreshResult.jwtPresentInResponse
            }
        });
        return;
    }
    Sentry.captureMessage('Intercom JWT refresh failed at boot', {
        level: 'warning',
        tags: {
            context: 'intercom_jwt_refresh_failed'
        },
        extra: {
            userId: identity.userId,
            userEmail: identity.email,
            refetchStatus: (_refreshResult_httpStatus = refreshResult.httpStatus) !== null && _refreshResult_httpStatus !== void 0 ? _refreshResult_httpStatus : 'no-response',
            errorMessage: refreshResult.errorMessage
        }
    });
};
